import { useParams } from "react-router-dom";
import { useWithoutAdvice } from "store/current-loan-application/hooks/mutations";
import { useGetCurrentLoanApplication } from "store/current-loan-application/hooks/queries";

import { DigitalAdvice } from "@krea/customer-features/layouts/advice/digital-advice";
import { ManualAdvice } from "@krea/customer-features/layouts/advice/manual-advice";
import { RevenueAdvice } from "@krea/customer-features/layouts/advice/revenue-advice";
import Preloader from "@krea/customer-features/shared-components/preloader";
import { AdviceCategoryEnum } from "@krea/customer-features/types/loanApplication";

export const AdvicePage = () => {
  const { loanApplicationID } = useParams();

  const { data, isLoading } = useGetCurrentLoanApplication(loanApplicationID);

  const { mutate: withoutAdvice } = useWithoutAdvice();

  const { adviceCategory } = data ?? {};

  const handleDigitalAdviceButtonClick = () => {
    // add custom logic here
    if (loanApplicationID) withoutAdvice({ loanApplicationID });
  };

  const handleManualAdviceButtonClick = () => {
    // add custom logic here
    if (loanApplicationID) withoutAdvice({ loanApplicationID });
  };

  if (isLoading) {
    return <Preloader className="tw-text-primary" size="xl" />;
  }

  if (adviceCategory === AdviceCategoryEnum.DIGITAL_REVENUE) {
    return (
      <RevenueAdvice onSendApplicationClick={handleDigitalAdviceButtonClick} />
    );
  }

  if (adviceCategory === AdviceCategoryEnum.DIGITAL_IMPROVEMENTS) {
    return (
      <DigitalAdvice onSendApplicationClick={handleDigitalAdviceButtonClick} />
    );
  }

  return (
    <ManualAdvice onSendApplicationClick={handleManualAdviceButtonClick} />
  );
};
